import { Activity, AlertCircle, Clock, UserX } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { StatCard } from '../types/liveOps.types'
import { LiveIndicator } from '../../../components/LiveIndicator'

const ICON_MAP: Record<'activity' | 'alert-circle' | 'user-x' | 'clock', LucideIcon> = {
  activity: Activity,
  'alert-circle': AlertCircle,
  'user-x': UserX,
  clock: Clock,
}

interface CommandCenterProps {
  stats: StatCard[]
}

export function CommandCenter({ stats }: CommandCenterProps): JSX.Element {
  return (
    <div className="mb-6">
      <div className="mb-2 flex items-center gap-3">
        <h1 className="text-[22px] font-bold leading-tight text-gray-900 sm:text-[28px]">Live Operations</h1>
        <LiveIndicator status="live" />
      </div>
      <p className="mb-5 text-[14px] text-gray-500">Real-time security operations overview</p>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-4">
        {stats.map((stat) => {
          const Icon = ICON_MAP[stat.icon] ?? Activity
          return (
            <div
              key={stat.label}
              className="flex items-start gap-3 rounded-xl border border-[#E5E7EB] bg-white p-4"
            >
              <Icon className={`mt-0.5 h-5 w-5 ${stat.color}`} />
              <div>
                <p className="text-[24px] font-bold leading-tight text-gray-900">{stat.value}</p>
                <p className="text-[13px] text-gray-500">{stat.label}</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
